import { z } from 'zod';
// =============================================================================
// Referral routes
// =============================================================================
/** `code` is null until the user has minted one: reading never mints. */
export const ReferralCodeResponseSchema = z.object({
    code: z.string().nullable(),
});
/** The response of the idempotent mint, which always has a code. */
export const MintedReferralCodeResponseSchema = z.object({
    code: z.string(),
});
export const ClaimReferralInputSchema = z.strictObject({
    code: z.string().min(1).max(32),
    idempotencyKey: z.string().min(1).max(255),
});
export const ClaimReferralResponseSchema = z.object({
    /** Null when nothing was recorded; the caller does not learn why. */
    referral: z
        .object({
        id: z.string(),
        createdAt: z.string(),
    })
        .nullable(),
});
export const AdminAccountReferralResponseSchema = z.object({
    referral: z
        .object({
        /** Null once the referrer's user has been deleted. */
        referrerUserId: z.string().nullable(),
        referrerName: z.string().nullable(),
        referrerEmail: z.string().nullable(),
        code: z.string(),
        createdAt: z.string(),
    })
        .nullable(),
});
